import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import ToursPage from "./pages/Tours.tsx";
import TourAngkorWatSunrise from "./pages/TourAngkorWatSunrise.tsx";
import TourBanteaySreiGrandCircuit from "./pages/TourBanteaySreiGrandCircuit.tsx";
import TourPhnomKulen from "./pages/TourPhnomKulen.tsx";
import TourKampongKleang from "./pages/TourKampongKleang.tsx";
import TourSiemReapThreeDay from "./pages/TourSiemReapThreeDay.tsx";
import TourCambodia7Day from "./pages/TourCambodia7Day.tsx";
import TourCambodia10Day from "./pages/TourCambodia10Day.tsx";
import TourCambodia18Day from "./pages/TourCambodia18Day.tsx";
import TourCambodia21Day from "./pages/TourCambodia21Day.tsx";
import TourCambodia25Day from "./pages/TourCambodia25Day.tsx";
import TourCambodia30Day from "./pages/TourCambodia30Day.tsx";
import TourSiemReap2Day from "./pages/TourSiemReap2Day.tsx";
import TourSiemReap2DayKulen from "./pages/TourSiemReap2DayKulen.tsx";
import TourSiemReap3DayKulenPhluk from "./pages/TourSiemReap3DayKulenPhluk.tsx";
import TourSiemReap4DayBengMealea from "./pages/TourSiemReap4DayBengMealea.tsx";
import TourSiemReap4Day from "./pages/TourSiemReap4Day.tsx";
import TourMonkBlessingVillage from "./pages/TourMonkBlessingVillage.tsx";
import TourOxcartVillage from "./pages/TourOxcartVillage.tsx";
import TourHomestayFarm from "./pages/TourHomestayFarm.tsx";
import TourPrekToal from "./pages/TourPrekToal.tsx";
import TourPrekToalHomestay from "./pages/TourPrekToalHomestay.tsx";
import TourKampongPhlukHomestay from "./pages/TourKampongPhlukHomestay.tsx";
import TourKampongKhleangHomestay from "./pages/TourKampongKhleangHomestay.tsx";
import TourPhnomKulenSrahDamrei from "./pages/TourPhnomKulenSrahDamrei.tsx";
import NotFound from "./pages/NotFound.tsx";
import Unsubscribe from "./pages/Unsubscribe.tsx";
import Blog from "./pages/Blog.tsx";
import BlogPost from "./pages/BlogPost.tsx";
import WhatsAppButton from "./components/site/WhatsAppButton.tsx";
import SeeAllToursButton from "./components/site/SeeAllToursButton.tsx";
import RouteSeo from "./components/site/RouteSeo.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <RouteSeo />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/tours" element={<ToursPage />} />
          <Route path="/tours/one-day-angkor-wat" element={<TourAngkorWatSunrise />} />
          <Route path="/tours/banteay-srei-grand-circuit" element={<TourBanteaySreiGrandCircuit />} />
          <Route path="/tours/phnom-kulen-waterfall" element={<TourPhnomKulen />} />
          <Route path="/tours/kampong-kleang" element={<TourKampongKleang />} />
          <Route path="/tours/siem-reap-4-day" element={<TourSiemReap4Day />} />
          <Route path="/tours/siem-reap-three-day" element={<TourSiemReapThreeDay />} />
          <Route path="/tours/cambodia-7-day" element={<TourCambodia7Day />} />
          <Route path="/tours/cambodia-10-day" element={<TourCambodia10Day />} />
          <Route path="/tours/cambodia-18-day" element={<TourCambodia18Day />} />
          <Route path="/tours/cambodia-21-day" element={<TourCambodia21Day />} />
          <Route path="/tours/cambodia-25-day" element={<TourCambodia25Day />} />
          <Route path="/tours/cambodia-30-day" element={<TourCambodia30Day />} />
          <Route path="/tours/siem-reap-2-day" element={<TourSiemReap2Day />} />
          <Route path="/tours/siem-reap-2-day-kulen" element={<TourSiemReap2DayKulen />} />
          <Route path="/tours/siem-reap-3-day-kulen-phluk" element={<TourSiemReap3DayKulenPhluk />} />
          <Route path="/tours/siem-reap-4-day-beng-mealea" element={<TourSiemReap4DayBengMealea />} />
          <Route path="/tours/khmer-village-monk-blessing" element={<TourMonkBlessingVillage />} />
          <Route path="/tours/village-oxcart-farm" element={<TourOxcartVillage />} />
          <Route path="/tours/life-farm-homestay" element={<TourHomestayFarm />} />
          <Route path="/tours/prek-toal-bird-sanctuary" element={<TourPrekToal />} />
          <Route path="/tours/prek-toal-homestay" element={<TourPrekToalHomestay />} />
          <Route path="/tours/kampong-phluk-homestay" element={<TourKampongPhlukHomestay />} />
          <Route path="/tours/kampong-khleang-homestay" element={<TourKampongKhleangHomestay />} />
          <Route path="/tours/phnom-kulen-srah-damrei" element={<TourPhnomKulenSrahDamrei />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppButton />
        <SeeAllToursButton />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
